import { useState } from 'react';

export default function useDialogControl() {
    const [open, setOpen] = useState(false);
    const handleOpenDialog = () => setOpen(true);
    const handleCloseDialog = () => setOpen(false);

    return {
        open,
        handleOpenDialog,
        handleCloseDialog,
    };
}
